import { isEmpty } from "lodash-es";

/**
 * The minimum an account-shaped value must expose to be ranked. Declared
 * structurally (rather than as the GraphQL `Account`) so REST v5 payloads —
 * which carry `vendorType` and no `vendor` relation — qualify without a cast.
 */
type RankableAccount = {
  id?: string;
  name?: string | null;
  avatarUrl?: string | null;
  vendorType?: string | null;
  vendor?: unknown;
};

/**
 * Pick the account to show for a user: the first one attached to a vendor,
 * else the first account at all.
 *
 */
export const getDefaultAccount = <T extends RankableAccount>(
  accounts: T[],
): T | undefined => {
  if (isEmpty(accounts)) {
    return undefined;
  }

  const accountWithVendor = accounts.find(
    (account) => !!account?.vendorType || !isEmpty(account?.vendor),
  );
  return accountWithVendor ?? accounts[0];
};
